import script from "./download_page.vue?vue&type=script&setup=true&name=download_page&lang=js"
export * from "./download_page.vue?vue&type=script&setup=true&name=download_page&lang=js"

import "./download_page.vue?vue&type=style&index=0&id=704b13ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-704b13ee"]])

export default __exports__